"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
const serialization_error_1 = require("./errors/serialization_error");
const metadata_1 = require("./metadata");
/**
 * Deflate class instance to a JSON-compatible object
 * @param serializable Serializable object
 * @returns JSON-compatible object which can be safely passed to `JSON.serialize`
 */
function deflate(serializable) {
    let jsonObj;
    if (serializable === null || serializable === undefined) {
        jsonObj = serializable;
    }
    else {
        const proto = Object.getPrototypeOf(serializable) || {};
        const meta = metadata_1.default.expectFor(proto);
        jsonObj = {};
        meta.props.forEach((serializer, name) => {
            const value = serializer.down(serializable[name]);
            if (value !== undefined) {
                jsonObj[name] = value;
            }
        });
    }
    return jsonObj;
}
exports.deflate = deflate;
/**
 * Construct/inflate class instance from JSON-compatible object
 * @param ctor Class instance constructor
 * @param jsonObj JSON-compatible object (e.g. returned from `JSON.parse`)
 * @returns Class instance
 */
function inflate(ctor, jsonObj) {
    let classInstance;
    if (jsonObj === null || jsonObj === undefined) {
        classInstance = jsonObj;
    }
    else {
        if (!ctor || !ctor.prototype) {
            throw new serialization_error_1.default('Expecting a valid constructor function');
        }
        const meta = metadata_1.default.expectFor(ctor.prototype);
        classInstance = new ctor();
        meta.props.forEach((serializer, name) => {
            const value = serializer.up(jsonObj[name]);
            if (value !== undefined) {
                classInstance[name] = value;
            }
        });
    }
    return classInstance;
}
exports.inflate = inflate;
var serialize_1 = require("./serialize");
exports.Serialize = serialize_1.default;
var serialization_error_2 = require("./errors/serialization_error");
exports.SerializationError = serialization_error_2.default;
//# sourceMappingURL=serialazy.js.map